/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Back_To_CompanyInputs */

const en_admin_create_company_user_back_to_company = /** @type {(inputs: Admin_Create_Company_User_Back_To_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to company`)
};

const de_admin_create_company_user_back_to_company = /** @type {(inputs: Admin_Create_Company_User_Back_To_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Unternehmen`)
};

/**
* | output |
* | --- |
* | "Back to company" |
*
* @param {Admin_Create_Company_User_Back_To_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_back_to_company = /** @type {((inputs?: Admin_Create_Company_User_Back_To_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Back_To_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_back_to_company(inputs)
	return en_admin_create_company_user_back_to_company(inputs)
});